import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

function includesIgnoreCase(source, target) {
    if (!target || target === 'ALL') {
        return true;
    }
    return String(source || '').toLowerCase().includes(String(target).toLowerCase());
}

function isCurrentEndDate(value) {
    if (!value) {
        return true;
    }
    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'current' || normalized.indexOf('9999-12-31') === 0) {
        return true;
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsed.setHours(0, 0, 0, 0);
    return parsed >= today;
}

function displayEndDate(value) {
    return isCurrentEndDate(value) ? 'Current' : value;
}

class GroupCompanyRegisterGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { field: 'id', headerName: 'dataID', pinned: 'left', cellClass: 'non-number', width: 80, checkboxSelection: true },
                { field: 'companyCode', headerName: 'Company Code', pinned: 'left', cellClass: 'non-number', width: 160, tooltipField: 'companyCode' },
                { field: 'information', headerName: 'Information', cellClass: 'non-number', width: 220, tooltipField: 'information' },
                { field: 'details', headerName: 'Details', cellClass: 'non-number', width: 320, tooltipField: 'details' },
                { field: 'effectiveDate', headerName: 'Effective Date', cellClass: 'non-number', width: 140 },
                { field: 'endDate', headerName: 'End Date', cellClass: 'non-number', width: 140, valueFormatter: params => displayEndDate(params.value) },
                { field: 'attachment', headerName: 'Attachment', cellClass: 'non-number', width: 220, tooltipField: 'attachmentOriginName', cellRenderer: this.attachmentCellRenderer },
                { field: 'lastUpdatedBy', headerName: 'Last Updated By', cellClass: 'non-number', width: 150 },
                { field: 'lastUpdateTime', headerName: 'Last Update Time', cellClass: 'non-number', width: 170 },
            ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50,
                sortable: true,
                filter: true,
                resizable: true,
            },
            sideBar: {
                toolPanels: ['columns', 'filters'],
                defaultToolPanel: '',
            },
            rowSelection: 'single',
            context: { componentParent: this },
        };
    }

    attachmentCellRenderer = params => {
        const data = params.data || {};
        const { attachment, attachmentOriginName } = data;
        if (!attachment) {
            return '';
        }

        const link = document.createElement('a');
        link.href = '#';
        link.innerText = attachmentOriginName || attachment;
        link.onclick = () => {
            this.props.openGroupCompanyRegisterDetailDialog(data);
            return false;
        };
        return link;
    }

    onSelectionChanged = event => {
        const rowNodeArray = event.api.getSelectedNodes();
        const selectedGroupCompanyRegisterArray = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectGroupCompanyRegister(selectedGroupCompanyRegisterArray);
    }

    filterRowData = rowData => {
        const { queryFields } = this.props;
        return rowData.filter(item => {
            if (!includesIgnoreCase(item.companyCode, queryFields.companyCode)) {
                return false;
            }
            if (!includesIgnoreCase(item.information, queryFields.information)) {
                return false;
            }
            if (queryFields.currentStatus === 'Current' && !isCurrentEndDate(item.endDate)) {
                return false;
            }
            return true;
        });
    }

    render() {
        const {
            queryGroupCompanyRegisterStatus,
            queryGroupCompanyRegisterResp,
        } = this.props;

        const isLoading = queryGroupCompanyRegisterStatus === ACTION_STATUS.LOGINING;
        const groupCompanyRegisterArray = !!queryGroupCompanyRegisterResp && !!queryGroupCompanyRegisterResp.data ? queryGroupCompanyRegisterResp.data : [];
        const presentDataArray = this.filterRowData(groupCompanyRegisterArray);

        return (
            <div className='ag-theme-balham grid-wrapper'>
                {isLoading ? (
                    <Loader active content='Loading...' />
                ) : (
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        rowData={presentDataArray}
                        defaultColDef={this.state.defaultColDef}
                        rowSelection={this.state.rowSelection}
                        suppressRowClickSelection={true}
                        suppressAggFuncInHeader={true}
                        animateRows={true}
                        immutableData={false}
                        enableRangeSelection={true}
                        context={this.state.context}
                        onSelectionChanged={this.onSelectionChanged}
                        sideBar={this.state.sideBar}
                    />
                )}
            </div>
        );
    }
}

export default GroupCompanyRegisterGrid;